import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Constants } from '../../../constants';
import { SecurityService } from '../../../services/security.service';
import { ErrorReportingService } from '../../../services/error-reporting.service';
import { AppConfigService } from '../../../services/app-config.service';
import { interval, Observable, PartialObserver, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'com-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.scss'],
})
export class AuthCallbackComponent implements OnInit {
  private timerId: any;
  userDataNotLoaded: boolean;
  errorLoadingData: boolean;
  userdataLoadTimeout: number;

  tryAgainTime: number;
  tryAgainTimer: Observable<number>;
  tryAgainObserver: PartialObserver<number>;
  tryAgainTimeUp = new Subject();
  tryAgainTimeRemaining: number;

  constructor(
    private security: SecurityService,
    private router: Router,
    private errorReporting: ErrorReportingService,
    env: AppConfigService
  ) {
    this.userdataLoadTimeout = env.config.userDataLoadingTimeout ?? 10000;
    this.tryAgainTime = env.config.userDataLoadingTimeout ?? 10000;
    this.tryAgainTimeRemaining = this.tryAgainTime / 1000;
  }

  async ngOnInit(): Promise<void> {
    this.userDataNotLoaded = false;

    this.timerId = setTimeout(() => {
      this.userDataNotLoaded = true;
      clearTimeout(this.timerId);
    }, this.userdataLoadTimeout);

    this.tryAgainTimer = interval(1000).pipe(takeUntil(this.tryAgainTimeUp));

    this.tryAgainObserver = {
      next: (_: number) => {
        if (this.tryAgainTimeRemaining == 0) {
          this.tryAgainTimeUp.next;
        }
        this.tryAgainTimeRemaining -= 1;
      },
    };

    await this.security
      .completeAuthentication()
      .then(async () => {
        clearTimeout(this.timerId);

        const user = this.security.user;
        const claims = user.profile;
        const accountRequires2FA = claims[Constants.claimTypes.multifactor] === 'true';
        this.security.profile.erauReference = claims[Constants.claimTypes.erauReference].toString();

        if (claims[Constants.claimTypes.isSuperUser]) {
          this.security.isSuperUser = claims[Constants.claimTypes.isSuperUser] === 'true';
        }

        this.security.saveProfile();

        if (!accountRequires2FA) {
          this.router.navigate(['unauthorised'], { replaceUrl: true });
        } else {
          this.router.navigate(['accounts', 'login'], { replaceUrl: true });
        }
      })
      .catch((err) => {
        clearTimeout(this.timerId);
        this.errorReporting.logError(err.message);
        this.userDataNotLoaded = false;
        this.errorLoadingData = true;
        this.tryAgainTimer.subscribe(this.tryAgainObserver);
        this.timerId = setTimeout(() => {
          clearTimeout(this.timerId);
          this.tryAgain();
        }, this.tryAgainTime);
      });
  }

  tryAgain() {
    this.security.logout();
  }
}
